/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./test.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "angular-highcharts";
import * as i3 from "./test.component";
import * as i4 from "@angular/common/http";
import * as i5 from "../../services/test-ser.service";
import * as i6 from "@angular/platform-browser";
import * as i7 from "../../services/fund.service";
var styles_TestComponent = [i0.styles];
var RenderType_TestComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_TestComponent, data: {} });
export { RenderType_TestComponent as RenderType_TestComponent };
export function View_TestComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" test works!\n"])), (_l()(), i1.ɵeld(2, 0, null, null, 1, "div", [["id", "container"]], null, null, null, null, null)), i1.ɵdid(3, 737280, null, 0, i2.ɵb, [i1.ElementRef], { chart: [0, "chart"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.chart; _ck(_v, 3, 0, currVal_0); }, null); }
export function View_TestComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-test", [], null, null, null, View_TestComponent_0, RenderType_TestComponent)), i1.ɵdid(1, 114688, null, 0, i3.TestComponent, [i4.HttpClient, i5.TestSerService, i6.DomSanitizer, i7.FundService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var TestComponentNgFactory = i1.ɵccf("app-test", i3.TestComponent, View_TestComponent_Host_0, {}, {}, []);
export { TestComponentNgFactory as TestComponentNgFactory };
